<button *ngIf="action.iconName" (click)="triggerAction(action.actionId)">
  <i [className]="action.iconName" aria-hidden="true"></i>
</button>
